import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

import LogoRus from "../../assets/images/logo-rus.svg";

import styles from "./Footer.module.scss";

const LinksSection = ({ list, scrollToTop, contact, links }) => {
  const contact_region = contact ? contact.region ? `${contact.region}, ${contact.city}` : contact.city : null;
  return (
    <section className={classNames(styles.FooterLayout, styles.LinksSection)}>
      <div>
        <Link to="/" className={classNames(styles.Logo, styles.HiddenOnMobile)}>
          <img src={LogoRus} alt="проектмаркетинг" />
        </Link>
        <div className={styles.MobileLogoWrapper}>
          <Link to="/" className={styles.footerLogo}>
            <img src={LogoRus} alt="проектмаркетинг" />
          </Link>

          <div className={styles.ButtonToTop} onClick={scrollToTop}>
            Наверх
          </div>
        </div>
        {contact_region && <p className={styles.FooterRegion}>{contact_region}</p> }
      </div>

      <div>
        <nav className={styles.Navigation}>
          {list &&
            list.length > 0 &&
            list.map((item, index) => {
              return (
                <Link
                  key={index}
                  to={item.url_text}
                  className={styles.NavigationItem}
                >
                  {item.title}
                </Link>
              );
            })}
        </nav>
      </div>

      <div>
        <div className={classNames(styles.Contacts, styles.HiddenOnMobile)}>
          {contact && contact.phone && (
            <a
              href={`tel:${contact.phone}`}
              className={styles.Telephone}
              target="_self"
            >
              {contact.phone}
            </a>
          )}

          {contact && contact.email && (
            <a
              href={`mailto:${contact.email}`}
              className={styles.Email}
              target="_self"
            >
              {contact.email}
            </a>
          )}

          {links}
        </div>
      </div>
    </section>
  );
};

export default LinksSection;
